import { ResponseImage } from '@src/components';
import logoMobile from '@src/assets/images/error/logo-edenred-mobile.svg';
import leftBackAction from '@src/assets/icons/icon-left-back.svg';
import '@src/styles/components/errorLayout.scss';

const ErrorLayout = ({ children, isBackButton }) => {
  return (
    <>
      {isBackButton && (
        <div className="mobile-header">
          <ResponseImage className="first-img" mobilImage={leftBackAction} />
          <ResponseImage className="second-img" mobilImage={logoMobile} />
        </div>
      )}
      <div className={isBackButton ? 'header-main' : 'main'}>{children}</div>
    </>
  );
};

export default ErrorLayout;
